import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer,Highchartscomponent, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';



Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});
const capital = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Vietnam', 'Thailand', 'Philippines', 'Malaysia', 'Indonesia','Singapore']
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Amount invested ($M USD)'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Total capital invested',
        data: [8, 109, 130, 244, 1717, 5330]
    }]
}


const capital2 = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['2013','2014','2015','2016','2017', '2018']
    },
    yAxis: {
        min: 0,
        title: {
            text: '# of deals'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Vietnam',
        data: [7, 9, 18, 29, 21, 7]
    },{
        name: 'Philippines',
        data: [20, 31, 35, 30, 15, 4]
    },{
        name: 'Thailand',
        data: [19, 17, 30, 29, 33, 10]
    },{
        name: 'Malaysia',
        data: [10, 27, 47, 78, 71, 26]
    },
    {
        name: 'Indonesia',
        data: [20, 48, 92, 91, 70, 19]
    },
    {
        name: 'Singapore',
        data: [142, 152, 230, 209, 211, 89]
    }]
}




export class ChapterFortyTwo extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>

        <TextHolder text="Singapore and Jakarta received the most startup funding of all cities in SEA between 2013 and 2018. Singapore received the greatest investment—$8.4 billion for 888 deals over that five-year period, compared to Jakarta’s $1.6 billion for 228 deals. Grab accounted for a sizeable chunk of the dollars invested in Singapore; the ride-hailing company raised $2 billion in July 2017 from Didi Chuxing and Softbank." />

          <TextHolder text="Only 46 deals were signed in Ho Chi Minh City, totaling $124 million—the smallest deal count and scoring the lowest in terms of total investment of the top five cities. Manila did not make the top five at all. In terms of startup funding, the Filipino capital is still catching up to its peers in the region; however, efforts by corporates and foreign funds in the country in the last year have been encouraging." />

          <TextHolder text="" />




        <Highchartscomponent   chartsText="Total capital invested by country (2017)" options={capital} notes="Notes: Countries represented: Singapore, Malaysia, Thailand, Philippines, Vietnam, Indonesia" source={<p>Source: <a href="https://www.crunchbase.com">Crunchbase</a>, Slush Singapore analysis</p>} chartsBottomText="When it comes to deal count, Singapore is nearly as dominant. In four years of the past five, it has had more than 50% of all deals in SEA."/>

        <Highchartscomponent   chartsText="Total number of deals by country (2013-2017)" options={capital2} notes="Notes: Only includes angel, seed, and series A through I and series unknown/undisclosed funding" source={<p>Source: <a href="https://www.crunchbase.com">Crunchbase</a>, Slush Singapore analysis</p>} chartsBottomText="Interestingly, while Indonesia received more than 100x the amount of funding as Malaysia in 2017-2018, Malaysia actually has a slightly higher deal count -- 97 to Indonesia’s 89. Singapore and Jakarta also top the list of cities receiving the most startup funding over the past five years. "/>

        <TextHolder textTitle="Top 5 cities by investments (2013-2018)" />
        <div className="block-outer block-outer-tableholder">
          <div className="block-inner block-inner-tableholder">
            <table id="t01">
            <tbody>
              <tr>
                <th>City</th>
                <th>Total # of investments (2013-2017)</th>
              </tr>
              <tr>
                <td>Singapore</td>
                <td>805</td>
              </tr>
              <tr>
                <td>Jakarta</td>
                <td>214</td>
              </tr>
              <tr>
                <td>Kuala Lumpur</td>
                <td>123</td>
              </tr>
              <tr>
                <td>Bangkok</td>
                <td>111</td>
              </tr>
              <tr>
                <td>Ho Chi Minh City</td>
                <td>44</td>
              </tr>
              </tbody>
            </table>
            <div className="highcharts-notes">
              <p> </p>
              <p> </p>
            </div>
        </div>
      </div>

      <div className="block-outer block-outer-tableholder">
        <div className="block-inner block-inner-tableholder">
          <table id="t01">
          <tbody>
            <tr>
              <th>City</th>
              <th>Median $ amount of investments (2013-2017) (*10 or mor inv.)</th>
            </tr>
            <tr>
              <td>Jakarta</td>
              <td>$1.5M</td>
            </tr>
            <tr>
              <td>Singapore</td>
              <td>$750K</td>
            </tr>
            <tr>
              <td>Bangkok</td>
              <td>$550K</td>
            </tr>
            <tr>
              <td>Kuala Lumpur</td>
              <td>$500K</td>
            </tr>
            <tr>
              <td>Ho Chi Minh City</td>
              <td>$500K</td>
            </tr>
            </tbody>
          </table>
          <div className="highcharts-notes">
            <p> </p>
            <p> </p>
          </div>
      </div>
    </div>
      <div className="block-outer block-outer-tableholder">
        <div className="block-inner block-inner-tableholder">
          <table id="t01">
          <tbody>
            <tr>
              <th>City</th>
              <th>Average $ amount of investments (2013-2017) (*10 or mor inv.)</th>
            </tr>
            <tr>
              <td>Jakarta</td>
              <td>$20.4M</td>
            </tr>
            <tr>
              <td>Singapore</td>
              <td>$13.1M</td>
            </tr>
            <tr>
              <td>Bangkok</td>
              <td>$4.7$M</td>
            </tr>
            <tr>
              <td>Kuala Lumpur</td>
              <td>$4.5M</td>
            </tr>
            <tr>
              <td>Ho Chi Minh City</td>
              <td>$4.2M</td>
            </tr>
            </tbody>
          </table>
          <div className="highcharts-notes">
            <p> </p>
            <p> </p>
          </div>
      </div>
    </div>
    <div className="block-outer block-outer-tableholder">
      <div className="block-inner block-inner-tableholder">
        <table id="t01">
        <tbody>
          <tr>
            <th>City</th>
            <th>Total $ amount of investments (2013-2017)</th>
          </tr>
          <tr>
            <td>Singapore</td>
            <td>$7.8B</td>
          </tr>
          <tr>
            <td>Jakarta</td>
            <td>$1.6B</td>
          </tr>
          <tr>
            <td>Kuala Lumpur</td>
            <td>$415M</td>
          </tr>
          <tr>
            <td>Bangkok</td>
            <td>$339M</td>
          </tr>
          <tr>
            <td>Ho Chi Minh City</td>
            <td>$121M</td>
          </tr>
          </tbody>
        </table>
        <div className="highcharts-notes">
          <p>Source: <a href="https://www.crunchbase.com">Crunchbase</a>, Slush Singapore analysis</p>
          <p> Notes: Only includes angel, seed, and series A through I and series unknown/undisclosed funding; Countries represented: Singapore, Malaysia, Thailand, Philippines, Vietnam, Indonesia</p>
        </div>
    </div>
  </div>

      <TextHolder text="In the past few years, several homegrown VCs have established themselves to support SEA tech startups. Their activities and successes have attracted international VCs to take a greater interest in the region as well. Our interviewees agreed that the availability of more funds is always welcome, no matter what their national origin." />
      <TextHolder text="As Kuo-Yi Lim of Monk’s Hill Ventures said: “The SEA tech ecosystem can always use more venture capital, particularly those from high-quality VC firms with value-add and relevant strategies, regardless of whether the firm is a homegrown or an international one. All bring expertise, enhancing the ecosystem. Hopefully this raises the bar in the venture capital community and keeps the current players on their toes.” " />
      <TextHolder text="When it comes to startup funding, Singapore doesn’t just lead the way among SEA cities, but among SEA nations, too. In 2017, startups in Singapore received almost three times as much funding as their Indonesian counterparts. Singapore also leads in deal count. Between 2013 and 2018, it grabbed more than 50 percent of all deals in SEA. Only in 2016 did Singapore slide a little, with 45 percent of all deals." />
      <TextHolder text="Obviously, entrepreneurs go where the funds are. They base themselves in the cities and countries where deals are most likely to be made, so that when they are ready for funding, they will be able to tap into those resources. If nations want to encourage startups and nurture a strong tech ecosystem, they must ensure their financial regulations support venture funding" />
      <TextHolder text="" />
          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/42.js